{
  "fr": {
    "cart": {
      "title": "Panier",
      "lead": "Rassemblez ce que vous voulez acheter en jeu et voyez où l'obtenir. Chaque article va à l'endroit le moins cher qui le vend, sauf si vous en choisissez un autre.",
      "addToCart": "Ajouter au panier",
      "addLoadout": "Ajouter les pièces non d'origine au panier",
      "clear": "Vider le panier",
      "confirmClear": "Retirer tout le contenu du panier ?",
      "remove": "Retirer",
      "quantity": "Quantité",
      "unitPrice": "%{price} l'unité",
      "buyElsewhere": "Acheter ailleurs",
      "cheapest": "Le moins cher",
      "planPick": "Laisser le plan choisir",
      "pinned": "Votre choix",
      "tripPick": "Choisi pour le trajet",
      "unplaced": "Lieu inconnu",
      "totals": {
        "total": "Total",
        "items": "Articles",
        "stops": "Arrêts",
        "unavailable": "Vendu nulle part"
      },
      "unavailable": {
        "title": "Vendu nulle part",
        "text": "À notre connaissance, personne ne vend ces articles en ce moment ; ils ne sont donc pas comptés dans le total."
      },
      "empty": {
        "title": "Votre panier est vide",
        "text": "Ajoutez des marchandises, des composants ou de l'équipement depuis le catalogue pour planifier où les acheter."
      },
      "messages": {
        "added": "%{name} ajouté à %{list}.",
        "addFailed": "Impossible d'ajouter l'article au panier.",
        "updateFailed": "Impossible de mettre à jour le panier.",
        "accountRequired": "Connectez-vous pour utiliser le panier.",
        "loadoutAdded": {
          "one": "%{count} pièce ajoutée à %{list}.",
          "other": "%{count} pièces ajoutées à %{list}."
        }
      },
      "lists": {
        "shown": "Liste",
        "create": "Nouvelle liste",
        "rename": "Renommer la liste",
        "delete": "Supprimer la liste",
        "name": "Nom",
        "activate": "Définir comme active",
        "isActive": "Liste active",
        "confirmDelete": "Supprimer la liste %{name} et tout son contenu ?",
        "messages": {
          "saveFailed": "Impossible d'enregistrer la liste."
        }
      },
      "widget": {
        "expand": "Afficher le panier",
        "collapse": "Masquer le panier",
        "open": "Ouvrir le panier",
        "unavailable": "Non vendu",
        "more": {
          "one": "+%{count} autre article",
          "other": "+%{count} autres articles"
        }
      },
      "strategies": {
        "cheapest": {
          "label": "Le moins cher",
          "hint": "Chaque article à l'endroit le moins cher qui le vend"
        },
        "stops": {
          "label": "Moins d'arrêts",
          "hint": "Tout acheter dans le moins d'endroits possible, en payant plus là où cela évite un arrêt"
        },
        "distance": {
          "label": "Trajet le plus court",
          "hint": "Garder les arrêts sur les mêmes planètes et dans le même système si possible, en payant plus là où cela évite du trajet"
        }
      },
      "pick": {
        "title": "Ajouter %{name} à une liste",
        "hint": {
          "one": "%{count} article",
          "other": "%{count} articles"
        },
        "activeHint": {
          "one": "Liste active · %{count} article",
          "other": "Liste active · %{count} articles"
        },
        "loadoutParts": "pièces non d'origine",
        "question": "Ajouter à :"
      },
      "fleetLists": {
        "title": "Listes d'achats",
        "lead": "L'équipement que la flotte veut voir chez ses membres : uniformes, armure, un équipement standard. Copie une liste dans ton panier pour voir ce qu'elle coûte et où tout acheter.",
        "count": {
          "one": "%{count} article",
          "other": "%{count} articles"
        },
        "copy": "Copier dans mon panier",
        "copyTitle": "Copier %{name} vers",
        "copyNew": "Une nouvelle liste",
        "copyNewHint": "Nommée %{name}, et définie comme ta liste active",
        "copyIntoHint": {
          "one": "Contient %{count} article ; les quantités s'additionnent",
          "other": "Contient %{count} articles ; les quantités s'additionnent"
        },
        "showItems": "Afficher les articles",
        "hideItems": "Masquer les articles",
        "edit": "Modifier",
        "delete": "Supprimer",
        "publish": "Publier une liste",
        "publishTitle": "Publier une de tes listes",
        "editTitle": "Modifier la liste d'achats",
        "source": "Ta liste",
        "sourceHint": "Ses articles et quantités sont copiés dans la flotte, pas les boutiques choisies.",
        "replaceFrom": "Remplacer les articles par",
        "replaceHint": "Laisse vide pour garder les articles tels quels.",
        "description": "Description",
        "confirmDelete": "Supprimer la liste d'achats %{name} ?",
        "empty": {
          "title": "Aucune liste d'achats pour l'instant",
          "text": "Les officiers publient ici des listes depuis leur propre panier, pour que les membres les copient dans le leur."
        },
        "messages": {
          "copied": "%{name} copiée dans %{list}.",
          "copyFailed": "Impossible de copier la liste dans ton panier.",
          "published": "%{name} publiée.",
          "updated": "%{name} mise à jour.",
          "saveFailed": "Impossible d'enregistrer la liste d'achats.",
          "deleted": "Liste d'achats supprimée.",
          "deleteFailed": "Impossible de supprimer la liste d'achats."
        }
      }
    }
  }
}
